export { default } from './VideoPage'
